export const sortRecordByValue = (
  record: Record<string, string>,
  language: string
) => {
  const possibleValuesEntries = Object.entries(record);
  return possibleValuesEntries.sort(([, a], [, b]) =>
    a.localeCompare(b, language)
  );
};
